import "../styles/HoldingSection.css";
import { Link } from "react-router-dom";
import FundPlanDesignSip from "./FundPlanDesignSip";
import defaultFundIcon from "../images/Default icon.svg";
import { useState } from "react";
import Loader from "../loader/Loader-ui";

const HoldingSectionSip = ({ data, isDashboard, loading }) => {
  console.log("data>>>>", data)
  const [activeId, setActiveId] = useState(null);
  const holdingsArray = Object.entries(data?.current_holdings || {});
  // Limit the data to 2 items if on the dashboard
  const limitedHoldingsArray = isDashboard
    ? holdingsArray.slice(0, 2)
    : holdingsArray;
// console.log("data",limitedHoldingsArray)
// console.log("isDashboard",isDashboard)
    const handleAccordionToggle = (id) => {
      setActiveId((prevActiveId) => (prevActiveId === id ? null : id)); // Update activeId
    };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
        <Loader />
      </div>
    );
  }

  return (
    <div>
      {limitedHoldingsArray.length > 0 ? (
        limitedHoldingsArray.map(([key, item], index) => (
          <div key={index} className="mb-3">
            {console.log("item?.pause_status",item?.pause_status)}
            <FundPlanDesignSip
            image={item?.icon ? `${process.env.REACT_APP_FUND_ICON_URL}/logos/${item?.icon}.png` : defaultFundIcon}
              bookmark={true}
              plus={true}
              id={key}
              title={item?.product_long_name || "-"}
              holdings_data={item?.holdings_data}
              allow_pause_sip={item?.allow_pause_sip}
              auto_trxn_no={item?.auto_trxn_no}
              ceased_status={item?.ceased_status}
              pause_status={item?.pause_status}
              cease_reason_codes={item?.cease_reason_codes}
              amc_product_id={item?.amc_product_id}
              activeId={activeId} 
              startInstallmentDate={item?.startInstallmentDate}
              endInstallmentDate={item?.endInstallmentDate}
              onToggleAccordion={handleAccordionToggle}
            />
          </div>
        ))
      ) : (
        <p>No SIP data available</p>
      )}
    </div>
  );
};

export default HoldingSectionSip;
